<template>
  <div class="ship-link-dialog">
    <custom-dialog class="afterSaleRole-item-dialog" width="400px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="content record-qrcode">
          <div class="qrcode-img">
            <qrcode-vue :value="`${qrCodeBaseUrl}${info.deliveryCodeStr}`" :size="106"></qrcode-vue>
          </div>
          <div class="href">
            {{ `${qrCodeBaseUrl}${info.deliveryCodeStr}` }}
          </div>
          <div class="copy-link">
            <span @click="copyLink(`${qrCodeBaseUrl}${info.deliveryCodeStr}`)">{{ $t('crm_ship_receiveLink_dialog.fu_zhi_lian_jie') }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import QrcodeVue from 'qrcode.vue';

export default {
  components: {
    QrcodeVue,
  },
  mixins: [dialogMixins],
  computed: {
    qrCodeBaseUrl() {
      const site = document.location.origin;
      // const site = 'https://tback.ice980.com';
      const url = this.qrCodeBase[site];
      return `${url}?No=`;
    },
  },
  data() {
    return {
      info: {},
      qrCodeBase: {},
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.info = this.model.data;
      this.getDictionary('crm_logistics_qrcode_address', (data) => {
        this.qrCodeBase = this.$transformDicValue(data.crm_logistics_qrcode_address);
      });
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    // 拷贝地址
    copyLink(link) {
      this.$copyToClip(link, this.$t('Common.com_copy_success'));
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
};
</script>

<style lang="scss">
.ship-link-dialog {
  .content {
    text-align: center;
    .qrcode-img {
      $r: 106px;
      width: $r;
      height: $r;
      margin-top: 17px;
      margin-left: auto;
      margin-right: auto;
    }

    .href {
      color: #495057;
      font-size: 12px;
      width: 178px;
      text-align: center;
      line-height: 17px;
      margin-top: 23px;
      margin-left: auto;
      margin-right: auto;
    }

    .copy-link {
      font-size: 12px;
      color: #35b8e0;
      text-align: center;
      margin-top: 9px;
      line-height: 28px;
      span {
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
